<template>
  <div class="container-fluid">
    <div class="mb-1">
      <b-card class="filtre-direccio">
        <b-row>
          <b-col lg="3" md="10" sm="12">
            <VariableMesos
              v-bind:initialValue="null"
              @mes-seleccionat="actualizarMesSeleccionat"
            />
          </b-col>
          <b-col lg="3" md="10" sm="12">
            <b-form-group
              class="input-group-var-any"
              id="input-group-2"
              label="Any: "
              label-size="sm"
              label-for="input-filtre-any"
              label-cols="4"
            >
              <b-form-select
                class="input-select-filtre"
                size="sm"
                id="input-filtre-any"
                v-model="anySeleccionat"
              >
                <template v-for="(item, idx) in anys">
                  <b-form-select-option
                    :key="'any-' + idx + '-' + item"
                    :value="item"
                  >
                    {{ item }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="10" sm="12">
            <VariableLiniaAssistencial
              v-bind:initialValue="null"
              @linia-assistencial="actualitzarLiniaAssistencial"
            />
          </b-col>
          <b-col lg="3" md="10" sm="12">
            <b-button
              size="sm"
              variant="outline-primary"
              @click.prevent="calcularGrafic()"
            >
              <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="10" sm="12">
            <span
              ><strong>Participants: {{ numeroTotalPersones }}</strong></span
            >
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="mb-1">
      <b-card class="filtre-direccio">
        <b-row
          class="text-center justify-content-center align-items-center"
          v-if="isLoading"
        >
          <b-spinner variant="primary"></b-spinner>
        </b-row>
        <b-row v-else>
          <b-col lg="auto" md="auto" sm="auto">
            <ModalTaulaResultatsEnquesta
              :data="questionsComunes"
              :mesos="mesosConsulta"
              :esPreguntaEspecifica="false"
              :esSatisfaccioFidelitat="esSatisfaccioFidelitat"
              :preguntaSeleccionadaGlobal="preguntaSeleccionada"
              v-on:pregunta-seleccionada="actualitzarPreguntaSeleccionada"
            />
            <ModalTaulaResultatsEnquesta
              :data="questionsEspecifiques"
              :mesos="mesosConsulta"
              :esPreguntaEspecifica="true"
              :esSatisfaccioFidelitat="esSatisfaccioFidelitat"
              :preguntaSeleccionadaGlobal="preguntaSeleccionada"
              v-on:pregunta-seleccionada="actualitzarPreguntaSeleccionada"
            />
            <ModalTaulaResultatsEnquesta
              :data="satisfaccioFidelitat"
              :mesos="mesosConsulta"
              :esPreguntaEspecifica="false"
              :esSatisfaccioFidelitat="true"
              :preguntaSeleccionadaGlobal="preguntaSeleccionada"
              v-on:pregunta-seleccionada="actualitzarPreguntaSeleccionada"
            />
          </b-col>
          <b-col lg="4" md="10" sm="12" class="order-first order-md-2 order-sm-2">
            <div>
              <p class="capcalera-titol-mapa">
                Regió seleccionada:
                {{
                  opcionsRegioSanitaria.find(
                    (option) => option.value === regioSeleccionada
                  )
                    ? opcionsRegioSanitaria.find(
                        (option) => option.value === regioSeleccionada
                      ).text
                    : ""
                }}
              </p>
              
              <div class="mapa-regio">
                <MapaCatalunya
                  :data="acumulatsPerPreguntaRegioSanitaria"
                  :pregunta="preguntaSeleccionada + 1"
                  v-on:regio-sanitaria="actualitzarRegioSanitaria"
                  :regioSanitariaSeleccionada="this.filtre.regioSanitaria"
                  v-on:sector-sanitari="posarPerDefecteSectorSanitari"
                  :liniaAssistencial="this.filtre.liniaAssistencial"
                />
                </div>
                <span class="capcalera-titol-mapa" v-show="esAtencioPrimaria">
                  <p v-if="regioSeleccionada !== 'barcelona-ciutat'">Sector seleccionat:</p>
                  <p v-else>Àrees integrals de salut (AIS) de Barcelona Ciutat:</p>
                  {{
                    opcionsSectorSanitari.find(
                      (option) => option.value === sectorSeleccionat
                    )
                      ? opcionsSectorSanitari.find(
                          (option) => option.value === sectorSeleccionat
                        ).text
                      : ""
                  }}
                </span>
                <div class="mapa-sector">
                 
                <MapaCatalunyaSectors
                  v-show="esAtencioPrimaria"
                  :data="acumulatsPerPreguntaSectorSanitari"
                  :pregunta="preguntaSeleccionada + 1"
                  :regioSanitariaSeleccionada="this.filtre.regioSanitaria"
                  :sectorSanitariSeleccionat="this.filtre.sectorSanitari"
                  v-on:sector-sanitari="actualitzarSectorSanitari"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import ModalTaulaResultatsEnquesta from "./ModalTaulaResultatsEnquesta.vue";
import resultatsService from "@/services/ResultatsService";
import VariableLiniaAssistencial from "./VariableLiniaAssistencial.vue";
import VariableMesos from "./VariableMesos.vue";
import MapaCatalunya from "./MapaCatalunya.vue";
import MapaCatalunyaSectors from "./MapaCatalunyaSectors.vue";
import tableauService from "@/services/TableauService";
//import loginService from "@/services/LoginService";

export default {
  name: "admin-direccio-enquestes",
  components: {
    ModalTaulaResultatsEnquesta,
    VariableLiniaAssistencial,
    VariableMesos,
    MapaCatalunya,
    MapaCatalunyaSectors,
  },
  data() {
    return {
      anys: ["2026","2025", "2024", "2023", "2022", "2021", "2020"],
      anySeleccionat: "",
      mesSeleccionat: "",
      filtre: {
        idActivacio: "",
        dataEfectiva: "",
        liniaAssistencial: "",
        regioSanitaria: "",
        sectorSanitari: "",
        resultats: [],
      },
      numeroTotalPersones: null,
      questionsComunes: [],
      questionsEspecifiques: [],
      satisfaccioFidelitat: [],
      enunciatsQuestionsComunes: [],
      enunciatsQuestionsEspecifiques: [],
      enunciatsSatisfacciofidelitat: [],
      mesosConsulta: [],
      esSatisfaccioFidelitat: false,
      isLoading: false,
      categoriaPregunta: null,
      acumulatsPerPreguntaRegioSanitaria: [],
      preguntaSeleccionada: 0,
      preguntaSeleccionadaGlobal: null,
      regioSeleccionada: null,
      sectorSeleccionat: null,
      acumulatsPerPreguntaSectorSanitari: [],
      esAtencioPrimaria: false,
      token: "",
      liniaAssistencial: "",
      opcionsRegioSanitaria: [
        {
          value: "alt-pirineu-aran",
          text: this.$t("variables.regio.alt-pirineu-aran"),
        },
        { value: "lleida", text: this.$t("variables.regio.lleida") },
        {
          value: "camp-tarragona",
          text: this.$t("variables.regio.camp-tarragona"),
        },
        { value: "terres-ebre", text: this.$t("variables.regio.terres-ebre") },
        {
          value: "catalunya-central",
          text: this.$t("variables.regio.catalunya-central"),
        },
        { value: "girona", text: this.$t("variables.regio.girona") },
        {
          value: "barcelona-ciutat",
          text: this.$t("variables.regio.barcelona-ciutat"),
        },
        {
          value: "metropolita-nord",
          text: this.$t("variables.regio.metropolita-nord"),
        },
        {
          value: "metropolita-sud",
          text: this.$t("variables.regio.metropolita-sud"),
        },
        {
          value: "penedes",
          text: this.$t("variables.regio.penedes"),
        },
      ],
      opcionsSectorSanitari: [
        {
          value: 6112,
          text: this.$t("variables.sector.6112"),
        },
        {
          value: 6113,
          text: this.$t("variables.sector.6113"),
        },
        {
          value: 7164,
          text: this.$t("variables.sector.7164"),
        },
        {
          value: 7107,
          text: this.$t("variables.sector.7107"),
        },
        {
          value: 6202,
          text: this.$t("variables.sector.6202"),
        },
        {
          value: 6201,
          text: this.$t("variables.sector.6201"),
        },
        {
          value: 6360,
          text: this.$t("variables.sector.6360"),
        },
        {
          value: 7001,
          text: this.$t("variables.sector.7001"),
        },
        {
          value: 6462,
          text: this.$t("variables.sector.6462"),
        },
        {
          value: 6461,
          text: this.$t("variables.sector.6461"),
        },
        {
          value: 7502,
          text: this.$t("variables.sector.7502"),
        },
        {
          value: 7501,
          text: this.$t("variables.sector.7501"),
        },
        {
          value: 7503,
          text: this.$t("variables.sector.7503"),
        },
        {
          value: 6701,
          text: this.$t("variables.sector.6701"),
        },
        {
          value: 7667,
          text: this.$t("variables.sector.7667"),
        },
        {
          value: 7644,
          text: this.$t("variables.sector.7644"),
        },
        {
          value: 7642,
          text: this.$t("variables.sector.7642"),
        },
        {
          value: 6745,
          text: this.$t("variables.sector.6745"),
        },
        {
          value: 7643,
          text: this.$t("variables.sector.7643"),
        },
        {
          value: 71,
          text: this.$t("variables.sector.71"),
        },
        {
          value: 46,
          text: this.$t("variables.sector.46"),
        },
        {
          value: 70,
          text: this.$t("variables.sector.70"),
        },
        {
          value: 47,
          text: this.$t("variables.sector.47"),
        },
        {
          value: 7347,
          text: this.$t("variables.sector.7347"),
        },
        {
          value: 7355,
          text: this.$t("variables.sector.7355"),
        },
        {
          value: 7354,
          text: this.$t("variables.sector.7354"),
        },
        {
          value: 7353,
          text: this.$t("variables.sector.7353"),
        },
        {
          value: 7352,
          text: this.$t("variables.sector.7352"),
        },
        {
          value: 7351,
          text: this.$t("variables.sector.7351"),
        },
        {
          value: 7346,
          text: this.$t("variables.sector.7346"),
        },
        {
          value: 7350,
          text: this.$t("variables.sector.7350"),
        },
        {
          value: 7348,
          text: this.$t("variables.sector.7348"),
        },
        {
          value: 7349,
          text: this.$t("variables.sector.7349"),
        },
        {
          value: 7403,
          text: this.$t("variables.sector.7403"),
        },
        {
          value: 7401,
          text: this.$t("variables.sector.7401"),
        },
        {
          value: 7402,
          text: this.$t("variables.sector.7402"),
        },
        {
          value: 7242,
          text: this.$t("variables.sector.7242"),
        },
        {
          value: 7267,
          text: this.$t("variables.sector.7267"),
        },
        {
          value: 7243,
          text: this.$t("variables.sector.7243"),
        },
        {
          value: 7244,
          text: this.$t("variables.sector.7244"),
        },
      ],
    };
  },
  methods: {
    actualizarMesSeleccionat(mes) {
      this.mesSeleccionat = mes;
    },
    actualizarPreguntaSeleccionadaGlobal(preguntaSeleccionada) {
      this.preguntaSeleccionadaGlobal = preguntaSeleccionada;
    },
    async calcularGrafic() {
      try {
        this.isLoading = true;
        //Construim la data amb el format que es requereix: dd-MM-AAAA 
        if (this.anySeleccionat !== "" && this.mesSeleccionat !== "") {
          const dataEfectivaConstruida = `${this.anySeleccionat}-${this.mesSeleccionat}-01`;
          this.filtre.dataEfectiva = dataEfectivaConstruida;
        }
        //Construim el filtre per fer la consulta
        if (
          this.regioSeleccionada === null ||
          this.regioSeleccionada === undefined
        ) {
          this.filtre.regioSanitaria = "";
        } else {
          this.filtre.regioSanitaria = this.regioSeleccionada;
        }
        if (
          this.sectorSeleccionat === null ||
          this.sectorSeleccionat === undefined
        ) {
          this.filtre.sectorSanitari = "";
        } else {
          this.filtre.sectorSanitari = this.sectorSeleccionat;
        }
        //Posem per defecte la pregunta seleccionada a la primera per evitar que al cambiar de liniaAssistencial es mostrin undefineds al mapa
        this.preguntaSeleccionada = 0;
        this.filtre.liniaAssistencial = this.liniaAssistencial;
        if (this.filtre.liniaAssistencial === "AP") {
          this.esAtencioPrimaria = true;
        } else {
          this.esAtencioPrimaria = false;
        }
        console.log("Filtre: " + JSON.stringify(this.filtre, null, 2));
        const response = await resultatsService.listFiltreAdminDireccioEnquesta(
          this.filtre
        );
        this.numeroTotalPersones = response.data.numeroTotalPersones;
        this.questionsComunes = response.data.questionsComunes;
        this.questionsEspecifiques = response.data.questionsEspecifiques;
        this.satisfaccioFidelitat = response.data.satisfaccioFidelitat;
        this.mesosConsulta = response.data.mesosConsulta;
        this.acumulatsPerPreguntaRegioSanitaria =
          response.data.acumulatsPerPreguntaRegioSanitaria;
        this.acumulatsPerPreguntaSectorSanitari =
          response.data.acumulatsPerPreguntaSectorSanitari;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    actualitzarRegioSanitaria(evt) {
      this.regioSeleccionada = evt;
      this.filtre.regioSanitaria = evt;
      this.sectorSeleccionat = null;
    },
    actualitzarSectorSanitari(evt) {
      this.sectorSeleccionat = evt;
      
    },
    posarPerDefecteSectorSanitari() {
      this.sectorSeleccionat = null;
      this.filtre.sectorSanitari = null;
    },
    actualitzarLiniaAssistencial(evt) {   
      this.liniaAssistencial = evt.valor;
    },
    actualitzarPreguntaSeleccionada(preguntaSeleccionada) {
      this.preguntaSeleccionada = preguntaSeleccionada;
    },
  },
  created() {
    this.isLoading = true;
    const path = this.$route.path;
    //Si entra al component per la ruta de access_key s'ha de comprovar que el access_key es correcte abans de fer la peticio al endpoint 
    //dels acumulats del back
    if (path.startsWith("/catsalut/t/")) {
      const accessKey = path.substring("/catsalut/t/".length);
      tableauService.logout();
      tableauService
        .tableauAccessKey(accessKey)
        .then((response) => {
          if (response.status == 200) {
            this.calcularGrafic();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      this.calcularGrafic();
    }
  },
  mounted() {
    if (this.anys.length > 0) {
      this.anySeleccionat = this.anys[0];
    }
  },
};
</script>
<style>
@media (max-width: 768px) {
  .mapa-sector{
    margin-left: -100px;
  }
}
.capcalera-titol-mapa {
  margin-bottom: 10px;
}
.label-titol-chart {
  font-weight: 500;
  font-size: 14px;
}

.botonera-resultats {
  text-align: right;
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn-eliminar-filtre-cerca {
  margin-top: 0px;
  display: none;
}

.item-filtre-quota {
  margin-bottom: 1px;
  font-size: 14px;
  text-align: left;
}

.item-filtre-resultats {
  text-align: left;
}

.item-filtre-resultats-hover .btn-eliminar-filtre-cerca {
  display: block;
  text-align: left;
}

.input-select-filtre {
  width: 180px;
}

.input-group-var-any .col {
  text-align: left;
}
</style>
